window.cookieComponent = function () {
    return {
        onFirstTab: true,
        functionalCookies: false,
        marketingCookies: false,
        analyticsCookies: false,
        showCookiePopup: false,
        display: 'initial_cookie_popup',
        handlingCookies: false,

        /**
         * Object with the scripts that need to be loaded when in the app
         * @type {{grantAnalyticsStorage: grantAnalyticsStorage, Usetiful: loadUsetiful,
         * Hubspot: Window.startHsTracking, GTM_events: sendEventsToGTM}}
         */
        appScripts: {
            'grantAnalyticsStorage': window.grantAnalyticsStorage,
            'Usetiful': window.loadUsetiful,
            'Hubspot': window.startHsTracking,
            'GTM_events': window.sendEventsToGTM,
        },

        /**
         * Object with the scripts that need to be loaded when on a jobsite
         * @type {{grantAnalyticsStorage: grantAnalyticsStorage, GTM_events: sendEventsToGTM,
         * Jobtoolz: startJTTracking, loadCompanyGA: loadCompanyGA,
         * grantAdStorage: grantAdStorage}}
         */
        jobsiteScripts: {
            'grantAnalyticsStorage': window.grantAnalyticsStorage,
            'grantAdStorage': window.grantAdStorage,
            'GTM_events': window.sendEventsToGTM,
            'Jobtoolz': window.startJTTracking,
            'loadCompanyGA': window.loadCompanyGA,
        },

        /**
         * Get the host of the current location
         *
         * Will either be 'app' or anything else. When it's 'app', we're on the app, otherwise we're on a jobsite.
         * @type {string}
         */
        host: location.host.split('.')[0],

        /**
         * Init function for AlpineJS to check if the user has already accepted or declined cookies.
         *
         * If the user has already accepted or declined cookies, we'll handle the cookies based on the consent.
         * If the user has not accepted or declined cookies, we'll show the initial cookie popup.
         *
         * Also, we'll hide the iframes when the user has not accepted the cookies.
         * @returns {void}
         */
        init() {
            this.$watch('showCookiePopup', (value) => {
                if (value) {
                    document.getElementById(this.display).classList.replace('hidden', 'flex');
                } else {
                    document.getElementById(this.display).classList.replace('flex', 'hidden');
                    this.handlingCookies = false;
                }
            });

            if (this.host === 'app') {
                window.hsTracking = window._hsp = window._hsp || [];
            }

            const toggleCookiePopupButton = document.getElementById('toggle_cookie_popup');
            if (toggleCookiePopupButton) {
                toggleCookiePopupButton.addEventListener('click', () => {
                    this.display = 'reset_cookie_popup';
                    this.showCookiePopup = true;
                    checkCookieContent(false);
                });
            }

            const closeCookiePopupButton = document.getElementById('cp_close');
            if (closeCookiePopupButton) {
                closeCookiePopupButton.addEventListener('click', () => {
                    this.showCookiePopup = false;
                });
            }

            if (this.hasConsented()) {
                let functional = window.getCookie(this.JTCookieName("functional_consent"));
                let marketing = window.getCookie(this.JTCookieName("marketing_consent"));
                let analytics = window.getCookie(this.JTCookieName("analytics_consent"));

                const hasAcceptedAll = [functional, marketing, analytics].every(consent => consent === 'true');
                if (!hasAcceptedAll) {
                    if (this.host !== 'app') {
                        this.hideIframes();
                    }
                }

                this.functionalCookies = getCookie(this.JTCookieName("functional_consent")) === 'true';
                this.marketingCookies = getCookie(this.JTCookieName("marketing_consent")) === 'true';
                this.analyticsCookies = getCookie(this.JTCookieName("analytics_consent")) === 'true';

                this.handleCookies(hasAcceptedAll, false);
            } else {
                this.showCookiePopup = true;
                if (this.host !== 'app') {
                    this.hideIframes();
                }
                checkCookieContent(true);
            }
        },

        /**
         * Get the JT cookie prefix based on the host
         * @param {string} name
         * @returns {string}
         * @constructor
         */
        JTCookieName(name) {
            switch (this.host) {
                case 'app':
                    return `jobtoolz_app_${name}`;
                default:
                    return `jobtoolz_${name}`;
            }
        },

        /**
         * Execute the scripts based on the host, and the consent.
         * Also, we'll check if the user has accepted all cookies, and if so, we'll unblock the iframes.
         * If not accepted, we'll make sure the iframes are hidden.
         * @param {boolean} acceptAll
         * @param {boolean} reset
         * @returns {void}
         */
        handleCookies(acceptAll, reset) {
            let scripts = this.host === 'app' ? this.appScripts : this.jobsiteScripts;
            Object.entries(scripts).forEach(([key, script]) => {
                switch (key) {
                    case 'grantAnalyticsStorage': // Google Tag Manager (analytics storage)
                    case 'Jobtoolz': // Jobtoolz tracking (jobsites only)
                    case 'loadCompanyGA': // Google Analytics from company
                        if ((this.analyticsCookies || acceptAll) && typeof script === 'function') {
                            script();
                        }
                        break;
                    case 'grantAdStorage': // Activate Google Analytics from company
                        if ((this.marketingCookies || acceptAll) && typeof script === 'function') {
                            script();
                        }
                        break;
                    case 'Usetiful': // Usetiful (user onboarding (app only)
                    case 'Hubspot': // Hubspot (marketing automation) (functional purpose only (showing chatbox))
                        if ((this.functionalCookies || acceptAll) && typeof script === 'function') {
                            script();
                        }
                        break;
                    case 'GTM_events': // Send events to Google Tag Manager
                        if (typeof script === 'function') {
                            let cookieChoices = [this.functionalCookies, this.marketingCookies, this.analyticsCookies];
                            script(acceptAll, cookieChoices);
                        }
                        break;
                }
            });
            if (acceptAll || (this.functionalCookies && this.marketingCookies && this.analyticsCookies)) {
                if (typeof window.iframeBlocker !== 'undefined' && window.iframeBlocker.isBlocked()) {
                    window.iframeBlocker.unblockIframes();
                }
            } else {
                if (this.host !== 'app') {
                    this.hideIframes();
                }
            }

            const showCookiePopupButton = document.getElementById('toggle_cookie_popup');
            if (showCookiePopupButton) {
                showCookiePopupButton.classList.remove('hidden'); // Show button when cookies have been handled
            }

            if (reset) {
                location.reload();
            } else {
                this.showCookiePopup = false;
            }
        },

        /**
         * Handle the respective cookie toggle.
         * HTML is calling this function with the details of the toggle, using AlpineJS.
         *
         * HTML can be found in resources/views/shared/cookie_popup.blade.php
         * @param {string} consentType
         * @param {boolean} checked
         * @returns {void}
         */
        handleCookieToggle(consentType, checked) {
            switch (consentType) {
                case 'functional': // Functional Cookies
                    this.functionalCookies = checked;
                    break;
                case 'marketing': // Marketing Cookies
                    this.marketingCookies = checked;
                    break;
                case 'analytics': // Analytics Cookies
                    this.analyticsCookies = checked;
                    break;
            }
        },

        /**
         * Set the cookies based on the consent.
         * Also checking the previous consent, and if anything changed from true to false, we'll reload the page, to make sure that any scripts that shouldn't be loaded are not loaded.
         * @param {boolean} acceptAll
         * @param {boolean} onFirstTab
         * @returns {void}
         */
        setCookies(acceptAll, onFirstTab) {
            this.handlingCookies = true;
            let previousConsent = [
                window.getCookie(this.JTCookieName("analytics_consent")),
                window.getCookie(this.JTCookieName("functional_consent")),
                window.getCookie(this.JTCookieName("marketing_consent"))
            ];

            if (!previousConsent.includes('true')) previousConsent = false;

            if (acceptAll) {
                this.functionalCookies = true;
                this.marketingCookies = true;
                this.analyticsCookies = true;
                window.setCookie(this.JTCookieName("analytics_consent"), 'true', 731);
                window.setCookie(this.JTCookieName("functional_consent"), 'true', 731);
                window.setCookie(this.JTCookieName("marketing_consent"), 'true', 731);
            } else {
                window.setCookie(this.JTCookieName("analytics_consent"), this.analyticsCookies ? 'true' : 'false', 731);
                window.setCookie(this.JTCookieName("functional_consent"), this.functionalCookies ? 'true' : 'false', 731);
                window.setCookie(this.JTCookieName("marketing_consent"), this.marketingCookies ? 'true' : 'false', 731);
            }

            let reset = false;

            if (previousConsent) {
                if (Array.isArray(previousConsent) && !acceptAll) {
                    let currentConsent = [
                        window.getCookie(this.JTCookieName("analytics_consent")),
                        window.getCookie(this.JTCookieName("functional_consent")),
                        window.getCookie(this.JTCookieName("marketing_consent"))
                    ];
                    if (previousConsent.some((consent, index) => consent === 'true' && currentConsent[index] === 'false')) {
                        reset = true;
                    }
                } else {
                    if (!acceptAll && onFirstTab) {
                        reset = true;
                    }
                }
            }

            this.handleCookies(acceptAll, reset);
        },

        /**
         * Load the iframeBlocker, only when it's not already loaded.
         *
         * Used to hide iframes, and replace them with a grey overlay when the user has not accepted the cookies.
         * @returns {Promise<unknown>}
         */
        async setIframeBlocker() {
            if (typeof window.iframeBlocker !== 'undefined') {
                return window.iframeBlocker;
            }
            const module = await import('../jobsites/iframeBlocker');
            window.iframeBlocker = module;
            return window.iframeBlocker;
        },

        /**
         * Hide iframes when the user has not accepted the cookies.
         * Uses the iframeBlocker to hide the iframes.
         * @returns {void}
         */
        hideIframes() {
            this.setIframeBlocker().then((instance) => {
                instance.blockIframes().then((iframes) => {
                    iframes.forEach((iframe) => {
                        iframe.addEventListener('click', (event) => {
                            event.preventDefault();
                            this.display = 'reset_cookie_popup';
                            this.showCookiePopup = true;
                        })
                    })
                })
            })
        },

        hasConsented() {
            return [
                window.getCookie(this.JTCookieName("functional_consent")),
                window.getCookie(this.JTCookieName("marketing_consent")),
                window.getCookie(this.JTCookieName("analytics_consent"))
            ].some(consent => consent !== null);
        }
    }
}

window.iframeBlocker = undefined;


/**
 * Get the cookie value by name.
 *
 * Returns null if the cookie does not exist
 *
 * @param {string} name
 * @returns {string|null}
 *
 * @example
 * getCookie('cookie_name');
 * window.getCookie('laravel_session');
 */
window.getCookie = function(name) {
    if (!name) {
        console.error('DEBUG...\n🍪 No cookie name provided 🍪')
        return null;
    }
    const cookies = Object.fromEntries(document.cookie.split('; ').map(cookie => cookie.split('=')));
    return cookies[name] ? decodeURIComponent(cookies[name]) : null;
}

/**
 * Set a cookie with a name, value and days to expire
 * @param {string} name
 * @param {string} value
 * @param {number} [days]
 * @returns {void}
 *
 * @example
 * setCookie('cookie_name', 'true', 30);
 * setCookie('cookie_name', '{foo: bar}'); // Session cookie
 */
window.setCookie = function(name, value, days) {
    const expires = days ? `; expires=${new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()}` : '';

    // Set secure cookie
    if (location.protocol === 'https:') {
        document.cookie = `${name}=${value || ''}${expires}; path=/; secure`;
    } else {
        document.cookie = `${name}=${value || ''}${expires}; path=/`;
    }
}

/**
 * Delete a cookie by name.
 *
 * Sets the cookie to expire in the past, effectively deleting it.
 * @param {string} name
 * @returns {void}
 */
const deleteCookie = function(name) {
    // check if cookie exists
    if (getCookie(name)) {
        // Set cookie to expire in the past
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    }
}

/**
 * Load Usetiful
 * @returns {void}
 */
window.loadUsetiful = () => {
    if (['production', 'testing'].includes(Jobtoolz.environment)) {
        (function (w, d, s) {
            var a = d.getElementsByTagName('head')[0];
            var r = d.createElement('script');
            r.async = 1;
            r.src = s;
            r.setAttribute('id', 'usetifulScript');
            r.dataset.token = "993c8eeeb4cc8783f44679340a47d04f";
            a.appendChild(r);
        })(window, document, "https://www.usetiful.com/dist/usetiful.js");
    }
}

/**
 * Stop Hubspot tracking
 * @returns {void}
 */
window.stopHsTracking = () => {
    if (Jobtoolz.environment === 'production') {
        window.hsTracking.push(['doNotTrack']);
    }
}

/**
 * Start Hubspot tracking
 * @returns {void}
 */
window.startHsTracking = () => {
    if (Jobtoolz.environment === 'production') {
        window.hsTracking.push(['doNotTrack', {track: true}]);
    }
}

/**
 * Send events to Google Tag Manager
 *
 * Will send custom events to Google Tag Manager based on the consent. When acceptAll is true, all events will be sent.
 *
 * Events:
 * - functional_consent
 * - marketing_consent
 * - analytics_consent
 *
 * If the event is already sent, it will not be sent again.
 * @param {boolean} acceptAll
 * @param {array} cookieChoices
 * @returns {void}
 */
window.sendEventsToGTM = (acceptAll, cookieChoices) => {
    if (typeof gtag !== 'function') {
        return;
    }

    const events = ['functional_consent', 'marketing_consent', 'analytics_consent'];
    if (acceptAll) {
        events.forEach(event => {
            if (!isEventAlreadySent(event)) {
                gtag('event', event);
            }
        })
    } else {
        const [functionalCookies, marketingCookies, analyticsCookies] = cookieChoices;
        // Send events based on the consent
        // We're only sending the events that are not already sent.
        if (functionalCookies && !isEventAlreadySent('functional_consent')) {
            gtag('event', 'functional_consent');
        }
        if (marketingCookies && !isEventAlreadySent('marketing_consent')) {
            gtag('event', 'marketing_consent');
        }
        if (analyticsCookies && !isEventAlreadySent('analytics_consent')) {
            gtag('event', 'analytics_consent');
        }
    }
}

/**
 * Sets Jobtoolz related cookies.
 *
 * This is only used on the jobsites, and gives us and the customer more insights into where the candidates are coming from.
 *
 * Cookies:
 * - jobtoolz-referrer
 * - jobtoolz-job-channel
 * - jobtoolz-campaign
 * - jobtoolz-campaign-source
 * - jobtoolz-vq-source
 * @returns {void}
 */
window.startJTTracking = () => {
    if (!getCookie('jobtoolz-referrer')) {
        // Set the current referrer
        setCookie('jobtoolz-referrer', document.referrer);
    }

    const params = new URLSearchParams(location.search)
    if (!getCookie('jobtoolz-job-channel') && params.has('utm_id') && params.has('utm_medium') && params.get('utm_medium') === 'organic') {
        setCookie('jobtoolz-job-channel', params.get('utm_id'));
    }

    if (params.has("utm_id") && params.has("utm_medium") && params.get("utm_medium") === "campaign") {
        setCookie("jobtoolz-campaign", params.get("utm_id"), 30);

        if (params.has("utm_source")) {
            setCookie("jobtoolz-campaign-source", params.get("utm_source"), 30);
        }
    }

    if (params.has("vq_source")) {
        setCookie("jobtoolz-vq-source", params.get("vq_source"), 30);
    }
}

/**
 * Check if an event is already sent to Google Tag Manager.
 * Based on the dataLayerJT array.
 *
 * We're only checking in dataLayerJT, because this one is loaded in both the app and the jobsites.
 * @param {string} event
 * @returns {boolean}
 */
const isEventAlreadySent = (event) => {
    const dataLayer = window.dataLayerJT;

    if (dataLayer && dataLayer.length > 0) {
        return !!dataLayer.find((item) => {
            return item[0] === 'event' && item[1] === event;
        })
    }
    return false;
}

/**
 * Check if the content of the cookie popup is larger than the container, and adds a fadeout if needed.
 *
 * Also adds a margin-bottom to the tabs, to make sure the content is not hidden behind the fadeout.
 * @param {boolean} initial
 * @returns {void}
 */
function checkCookieContent(initial) {
    let cp_content = document.getElementById((initial ? 'initial' : 'reset') + '_cp_content');
    let fadeout = document.getElementById((initial ? 'initial' : 'reset') + '_cp_fadeout');
    if (cp_content.scrollHeight > cp_content.clientHeight && fadeout.classList.contains('hidden')) {
        fadeout.classList.remove('hidden');
        if (initial) {
            document.getElementById('initial_cp_content_first_tab').classList.add('-mb-50');
            document.getElementById('initial_cp_content_second_tab').classList.add('-mb-50');
        }
    } else if (cp_content.scrollHeight <= cp_content.clientHeight && !fadeout.classList.contains('hidden')) {
        fadeout.classList.add('hidden');
        if (initial) {
            document.getElementById('initial_cp_content_first_tab').classList.remove('-mb-50');
            document.getElementById('initial_cp_content_second_tab').classList.remove('-mb-50');
        }
    }
}

/**
 * Resize event listener to check if the content of the cookie popup is larger than the container.
 * @returns {void}
 */
window.addEventListener('resize', () => {
    const initialCookiePopup = document.getElementById('initial_cookie_popup');
    const resetCookiePopup = document.getElementById('reset_cookie_popup');
    if ((initialCookiePopup && !initialCookiePopup.classList.contains('hidden')) || (resetCookiePopup && !resetCookiePopup.classList.contains('hidden'))) {
        checkCookieContent(!initialCookiePopup.classList.contains('hidden'));
    }
});
